<template>
  <div class="order-circle-chart-container" v-if="entry.total_count">
    <div class="system-name">{{ entry.mode }}</div>
    <div class="chart-container">
      <vc-donut
        background="#e5e5e5"
        foreground="transparent"
        :size="100"
        unit="%"
        :thickness="22"
        :total="entry.total_count"
        :sections="sections"
        ><div class="percents">
          {{ entry.total_count }}<span>{{ $t("stats_circle.total") }}</span>
        </div></vc-donut
      >
    </div>
    <div class="stat-info-container">
      <div class="stat-info-item">
        <span class="common">{{ entry.accepted_count }}</span>
        {{ $t("stats_circle.accepted") }}
      </div>
      <div class="stat-info-item">
        <span class="danger">{{ entry.cancelled_count }}</span>
        {{ $t("stats_circle.cancelled") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    entry: Object,
  },
  computed: {
    sections() {
      return [
        { value: this.entry.accepted_count, color: "#AECCC6" },
        { value: this.entry.cancelled_count, color: "#E2223B" },
      ];
    },
  },
};
</script>
<style scoped>
.order-circle-chart-container {
  background: #e5e5e5;
  border-radius: 1.333vh;
  width: calc(25% - 2.222vh);
  padding: 2.22vh;
  margin-right: 2.222vh;
}
.order-circle-chart-container:last-child {
  margin-right: 0;
}
.system-name {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #000000;
  width: 100%;
}
.chart-container {
  width: 100%;
  padding: 2.22vh 0;
  position: relative;
}
.stat-info-container {
  display: flex;
  justify-content: space-between;
}
.stat-info-item {
  width: calc(50% - 1.111vh);
  font-size: 1.1111111111111112vh;
  line-height: 1.3333333333333333vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.stat-info-item span {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
}
.common {
  color: #aeccc6;
}
.danger {
  color: #e2223b;
}
.percents {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #1d1d1b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.percents span {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
</style>
